
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35268',
  depVersions: {
  "documents-public-ui": "static-1.35268",
  "atom": "static-1.5418",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2818",
  "client-types": "static-1.501",
  "cssUtils": "static-1.958",
  "customer-data-filters-ui": "static-1.41008",
  "customer-data-objects": "static-1.8033",
  "customer-data-property-utils": "static-1.8434",
  "documents-lib": "static-1.35273",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.373",
  "FormsCommonComponents": "static-1.86635",
  "FormUrlGenerator": "static-2.5062",
  "foundations-theming-specialty": "static-1.2528",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5926",
  "hs-test-utils": "static-1.8369",
  "hub-http": "static-1.6548",
  "hubspot-dlb": "static-2.1905",
  "HubStyle": "static-2.12134",
  "HubStyleTokens": "static-2.11827",
  "I18n": "static-7.1679",
  "icons": "static-2.693",
  "jasmine-immutable": "static-1.3356",
  "jasmine-runner": "static-1.6786",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7489",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3228",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5730",
  "quartz": "static-1.7502",
  "react": "static-7.196",
  "react-dlb": "static-1.89",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.79",
  "react-rhumb": "static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5579",
  "react-virtualized": "static-2.107",
  "reference-resolvers": "static-1.8517",
  "reference-resolvers-lite": "static-1.8440",
  "reporting-data": "static-1.68910",
  "reporting-reports": "static-1.68586",
  "reporting-snowflake": "static-1.57526",
  "reporting-testing-lib": "static-1.10843",
  "reporting-visualizations": "static-1.60984",
  "reselect": "static-3.12",
  "sales-content-partitioning": "static-1.9288",
  "sanitize": "static-1.4808",
  "sanitize-text": "static-1.8493",
  "SharedI18nStrings": "static-1.183",
  "SharedLegalStrings": "static-1.2078",
  "signup-constants": "static-1.19681",
  "signup-ui-url-generator": "static-2.8396",
  "StyleGuideUI": "static-3.507",
  "superstore": "static-1.5095",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5092",
  "ui-addon-form-validation": "static-1.11320",
  "ui-asset-management-lib": "static-1.11435",
  "ui-images": "static-2.1261",
  "UIComponents": "static-3.8773",
  "usage-tracker": "static-1.7649",
  "usage-tracker-container": "static-1.7639",
  "usage-tracker-core": "static-1.7499",
  "viral-links-lib": "static-1.7412",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9989",
  "foundations-components": "static-1.8539",
  "immutable": "static-2.87",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1280",
  "quartz-core": "static-1.6721",
  "quick-fetch": "static-1.4151",
  "raven": "static-3.5925",
  "redux": "static-4.80",
  "redux-thunk": "static-2.80",
  "rpc-client-utils": "static-1.5002",
  "ui-addon-i18n": "static-1.11482",
  "ui-addon-upgrades": "static-9.18424",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4366",
  "metrics-js": "static-1.9963",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3779",
  "quartz-webpack": "static-1.3726",
  "foundations-assets": "static-1.5222",
  "foundations-theming": "static-1.4812",
  "hub-http-janus": "static-1.887",
  "hub-http-shared-msw-handlers": "static-1.10671",
  "hubspotter-http": "static-1.4887",
  "sassPrefix": "static-1.225",
  "conversations-skeleton-state": "static-1.7583",
  "crm-message-bus": "static-1.43826",
  "customer-data-filters-ui-msw-helpers": "static-1.23443",
  "customer-data-objects-ui-components": "static-1.13367",
  "customer-data-reference-ui-components": "static-1.13515",
  "customer-data-ui-utilities": "static-1.10167",
  "events-data-lib": "static-1.584",
  "framework-builder-read-service-client": "static-1.4245",
  "hs-resources": "static-1.528",
  "immer": "static-1.101",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4071",
  "multi-account-reference-resolvers": "static-1.1343",
  "onboarding-scopes": "static-1.6789",
  "onboarding-tours": "static-1.17173",
  "pulse": "static-1.965",
  "reporting-datasets-permissions-lib": "static-1.14521",
  "stylex": "static-1.41",
  "trellis-assets": "static-1.2730",
  "trellis-components": "static-1.2749",
  "trellis-theming": "static-1.1309",
  "ui-addon-teams": "static-1.21946",
  "quartz-auth": "static-1.1177",
  "ui-business-units-lib": "static-1.9427",
  "usage-tracker-session-replay": "static-1.5335",
  "ai-components-ui-library": "static-1.9783",
  "ContentUtils": "static-1.69187",
  "customer-data-properties": "static-1.52679",
  "forms-ai-lib": "static-1.4804",
  "forms-utils-lib": "static-1.13134",
  "foundations-components-test-utils": "static-1.6022",
  "react-dnd-compat": "static-1.4952",
  "react-tinymce": "static-1.56034",
  "tinymce-config": "static-2.55160",
  "ui-gdpr-components": "static-1.10632",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3797",
  "HeadJS": "static-2.803",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3480",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "hs-locale-management": "static-1.318",
  "ui-fonts": "static-1.1089",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4648",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1167",
  "web-vitals": "static-1.15",
  "batch-promise": "static-1.1881",
  "external-options-client-types": "static-1.4364",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7229",
  "quartz-i18n": "static-1.1177",
  "frontend-preferences-client": "static-1.8254",
  "graphql": "static-1.89",
  "persist-promise": "static-1.4038",
  "reporting-client-types": "static-1.2714",
  "apollo-stack-hubspot": "static-3.94",
  "growth-payments-core": "static-1.26245",
  "hubspot-apollo-client": "static-1.5213",
  "foundations-components-legacy": "static-1.1564",
  "quartz-routing": "static-1.932",
  "hs-story-utils": "static-1.9761",
  "react-flip-move": "static-1.78",
  "nested-table": "static-1.571",
  "seat-types-lib": "static-1.796",
  "timezone-utils": "static-2.5579",
  "react-create-root-preference": "static-1.78",
  "bend-plugin-foundations-components": "static-1.4808",
  "floating-ui": "static-1.63",
  "react-aria": "static-1.72",
  "tanstack-table": "static-1.61",
  "opentelemetry-fe-types": "static-1.112",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.583",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.487",
  "quartz-test": "static-1.1177",
  "quartz-tracking": "static-1.881",
  "bend-plugin-chirp-manifest": "static-1.412",
  "chirp-fetch": "static-1.2232",
  "merchandise-lib": "static-1.279",
  "purchase-motions-components": "static-1.6408",
  "ts-schema": "static-1.4317",
  "bender-build-tools": "static-1.3452",
  "bend-plugin-foundations-theming": "static-1.3295",
  "restore-request-side-panel-lib": "static-1.1735",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4993",
  "conditional-properties-service-client": "static-1.4040",
  "crm-pipelines-api-client-types": "static-1.4371",
  "event-emitter": "static-1.1291",
  "fdsr-migration-layer": "static-1.348",
  "multi-currency-client-types": "static-1.3931",
  "getting-started-shared-tasks": "static-1.19304",
  "growth-data-modal": "static-1.5936",
  "growth-onboarding-confetti": "static-1.3401",
  "growth-onboarding-next-action-utils": "static-1.2746",
  "navigation-components": "static-1.18893",
  "onboarding-tours-client": "static-1.5388",
  "onboarding-tours-utils": "static-1.1240",
  "ui-shepherd-react": "static-3.10605",
  "ui-shepherd-tracker": "static-1.7986",
  "ui-universal-auth": "static-1.9459",
  "user-context": "static-1.5457",
  "bend-plugin-pulse": "static-1.468",
  "fast-json-patch": "static-1.70",
  "stylex-utils": "static-1.147",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "hubspotter-http-shared-msw-handlers": "static-1.10669",
  "magpie-lib": "static-1.5782",
  "navigation-messaging": "static-1.8220",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23183",
  "copilot-toolkit": "static-1.11899",
  "cms-field-types": "static-1.5148",
  "content-icons-ui": "static-1.2399",
  "integrations-lib": "static-1.17119",
  "calling-global-api": "static-1.65717",
  "calling-internal-common": "static-1.31658",
  "calling-lifecycle-internal": "static-1.67099",
  "calling-lifecycle-messages": "static-1.59393",
  "commerce-products-lib": "static-1.10604",
  "crm-index-visualization-core": "static-1.4583",
  "crm-links": "static-1.6658",
  "customer-data-properties-shared-msw-handlers": "static-1.9998",
  "file-manager-components": "static-1.24574",
  "formula-editor": "static-1.14813",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4452",
  "meetings-icalendar-utils-lib": "static-1.971",
  "object-builder-ui-client": "static-1.49751",
  "pipeline-validation-client-types": "static-1.4206",
  "property-value-citations": "static-1.3293",
  "smart-data-capture-core": "static-1.192",
  "smart-property-lib": "static-1.8361",
  "tiered-pricing": "static-1.2007",
  "topics-actions-lib": "static-1.504",
  "trial-components-library": "static-1.14158",
  "ui-addon-iframeable": "static-1.9413",
  "zustand": "static-1.85",
  "final-form": "static-1.78",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.78",
  "rich-text-lib": "static-1.20349",
  "tinymce-themes": "static-1.57130",
  "data-token-picker": "static-1.16929",
  "hub-http-contrib": "static-1.3376",
  "interframe": "static-3.5091",
  "tinymce-data": "static-1.41245",
  "tinymce-plugins": "static-1.58274",
  "ui-addon-sales-email": "static-1.5550",
  "framework-data-schema-quick-fetch": "static-1.7134",
  "ui-addon-opt": "static-4.8702",
  "hubspot-apollo-cache": "static-1.672",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.484",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.40",
  "purchase-motions-api": "static-1.6411",
  "onboarding-data-sync-lib": "static-1.2559",
  "growth-onboarding-next-action-components": "static-1.2774",
  "user-context-client": "static-1.4844",
  "idb-keyval": "static-1.51",
  "magpie-types": "static-1.5242",
  "nest": "static-1.573",
  "reactive-lib": "static-1.1055",
  "simple-logging-lib": "static-1.3387",
  "unified-auth-core-lib": "static-1.1255",
  "getting-started-shared-tasks-store": "static-1.18422",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1821",
  "integrations-error-boundary-lib": "static-1.14534",
  "integrations-tracking-lib": "static-1.5944",
  "native-integrations-shared-strings": "static-1.8113",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10706",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.973",
  "calling-error-reporting": "static-1.31665",
  "shared-worker-versioning": "static-1.11377",
  "calling-usage-tracker": "static-1.6872",
  "voice-sms-access-library": "static-1.2125",
  "customer-data-tracking": "static-1.7218",
  "commerce-permissions": "static-1.1113",
  "products-iframe-lib": "static-1.8641",
  "products-ui-components-shared-msw-handlers": "static-1.11053",
  "crm-index-associations-lib": "static-1.6780",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10754",
  "sales-views-client-types": "static-1.4592",
  "location-customization-utils-lib": "static-1.10159",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4482",
  "video-components-external": "static-1.12201",
  "video-data-lib": "static-1.35859",
  "bark-lib": "static-1.16850",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6226",
  "react-codemirror": "static-1.10979",
  "data-agent-kit": "static-1.694",
  "feedback-loader": "static-1.29853",
  "fsm": "static-1.4088",
  "policy-lib": "static-1.7140",
  "react-colorpicker": "static-2.10549",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10817",
  "embedded-academy-lib": "static-1.15609",
  "hubs-service-types": "static-1.1596",
  "salesImages": "static-1.596",
  "FileManagerLib": "static-1.40214",
  "NamespacedHubStyle": "static-2.9289",
  "FileManagerCore": "static-1.40073",
  "content-assistance-lib": "static-1.8241",
  "layout-dnd-components": "static-1.13015",
  "layout-dnd-utils": "static-1.11990",
  "ui-addon-emoji-picker": "static-1.10220",
  "ui-brand-identity-lib": "static-1.16604",
  "InboxConnectUtils": "static-4.15612",
  "meetings-connect-utils-lib": "static-1.7947",
  "breeze-engine-chat-components": "static-1.799",
  "breeze-engine-core": "static-1.1099",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "universal-page-editor-lib": "static-1.3344",
  "adobe-sign-auth-lib": "static-1.522",
  "ads-unified-auth-lib": "static-1.1496",
  "custom-vendor-connection-lib": "static-1.23",
  "google-sheets-integration-lib": "static-1.1087",
  "microsoft-drive-auth-lib": "static-1.203",
  "surveymonkey-integration-lib": "static-1.542",
  "slack-ui-library": "static-1.10735",
  "calling-orchestration-schema": "static-1.36902",
  "crm-record-cards-service-types": "static-1.3796",
  "content-media-composition-data-lib": "static-1.13310",
  "content-media-compositions": "static-2.17317",
  "media-bridge-lib": "static-1.19447",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16420",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4843",
  "storybook-react": "static-1.40",
  "academy-common-lib": "static-1.15069",
  "audio-components": "static-1.6388",
  "FileManagerImages": "static-1.37725",
  "video-components": "static-1.14203",
  "breeze-artifacts-sdk": "static-1.445",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4866",
  "video-embed": "static-1.36693",
  "ui-addon-video-player": "static-1.9038",
  "ui-coaching-tips": "static-1.29365",
  "ContentData": "static-1.69262",
  "layout-data-lib": "static-1.10315",
  "academy-service-client": "static-1.4028",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4742",
  "trellis-ecosystem": "static-1.7669",
  "ui-addon-react-router-dom": "static-1.9868",
  "wootric-nps": "static-1.7224",
  "social-insights-client-types": "static-1.22706",
  "outpost": "static-1.4489",
  "growth-onboarding-feedback-components": "static-1.6921",
  "advanced-menus-core": "static-1.15620",
  "advanced-menus-lib": "static-1.12492",
  "ExportDialog": "static-6.10714",
  "ui-memberships-settings-lib": "static-1.34899",
  "marketplace-ui-apps-core": "static-1.19325",
  "marketplace-ui-common": "static-1.20793",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15619",
  "simple-menus-lib": "static-1.17136",
  "settings-ui-lib": "static-1.12860",
  "developer-experience-shared-components": "static-1.10874",
  "immutable-less": "static-1.4987",
  "marketplace-ui-client-types": "static-1.18200",
  "ui-addon-integrations-directory-panel": "static-2.8363",
  "ui-extensibility-client-types": "static-1.4253",
  "ai-settings-ui-library": "static-1.8386",
  "nav-meta": "static-1.30530",
  "ui-product-approvals-common": "static-1.1152",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4569",
  "simple-data-table": "static-1.3571"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35268",
  "atom": "/atom/static-1.5418",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2818",
  "client-types": "/client-types/static-1.501",
  "cssUtils": "/cssUtils/static-1.958",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41008",
  "customer-data-objects": "/customer-data-objects/static-1.8033",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8434",
  "documents-lib": "/documents-lib/static-1.35273",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.373",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86635",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5062",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2528",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5926",
  "hs-test-utils": "/hs-test-utils/static-1.8369",
  "hub-http": "/hub-http/static-1.6548",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "HubStyle": "/HubStyle/static-2.12134",
  "HubStyleTokens": "/HubStyleTokens/static-2.11827",
  "I18n": "/I18n/static-7.1679",
  "icons": "/icons/static-2.693",
  "jasmine-immutable": "/jasmine-immutable/static-1.3356",
  "jasmine-runner": "/jasmine-runner/static-1.6786",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7489",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3228",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5730",
  "quartz": "/quartz/static-1.7502",
  "react": "/react/static-7.196",
  "react-dlb": "/react-dlb/static-1.89",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.79",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5579",
  "react-virtualized": "/react-virtualized/static-2.107",
  "reference-resolvers": "/reference-resolvers/static-1.8517",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8440",
  "reporting-data": "/reporting-data/static-1.68910",
  "reporting-reports": "/reporting-reports/static-1.68586",
  "reporting-snowflake": "/reporting-snowflake/static-1.57526",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10843",
  "reporting-visualizations": "/reporting-visualizations/static-1.60984",
  "reselect": "/reselect/static-3.12",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9288",
  "sanitize": "/sanitize/static-1.4808",
  "sanitize-text": "/sanitize-text/static-1.8493",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2078",
  "signup-constants": "/signup-constants/static-1.19681",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8396",
  "StyleGuideUI": "/StyleGuideUI/static-3.507",
  "superstore": "/superstore/static-1.5095",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5092",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11320",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11435",
  "ui-images": "/ui-images/static-2.1261",
  "UIComponents": "/UIComponents/static-3.8773",
  "usage-tracker": "/usage-tracker/static-1.7649",
  "usage-tracker-container": "/usage-tracker-container/static-1.7639",
  "usage-tracker-core": "/usage-tracker-core/static-1.7499",
  "viral-links-lib": "/viral-links-lib/static-1.7412",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9989",
  "foundations-components": "/foundations-components/static-1.8539",
  "immutable": "/immutable/static-2.87",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1280",
  "quartz-core": "/quartz-core/static-1.6721",
  "quick-fetch": "/quick-fetch/static-1.4151",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.80",
  "redux-thunk": "/redux-thunk/static-2.80",
  "rpc-client-utils": "/rpc-client-utils/static-1.5002",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11482",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18424",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "metrics-js": "/metrics-js/static-1.9963",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3779",
  "quartz-webpack": "/quartz-webpack/static-1.3726",
  "foundations-assets": "/foundations-assets/static-1.5222",
  "foundations-theming": "/foundations-theming/static-1.4812",
  "hub-http-janus": "/hub-http-janus/static-1.887",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10671",
  "hubspotter-http": "/hubspotter-http/static-1.4887",
  "sassPrefix": "/sassPrefix/static-1.225",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7583",
  "crm-message-bus": "/crm-message-bus/static-1.43826",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23443",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13367",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13515",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10167",
  "events-data-lib": "/events-data-lib/static-1.584",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4245",
  "hs-resources": "/hs-resources/static-1.528",
  "immer": "/immer/static-1.101",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4071",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1343",
  "onboarding-scopes": "/onboarding-scopes/static-1.6789",
  "onboarding-tours": "/onboarding-tours/static-1.17173",
  "pulse": "/pulse/static-1.965",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14521",
  "stylex": "/stylex/static-1.41",
  "trellis-assets": "/trellis-assets/static-1.2730",
  "trellis-components": "/trellis-components/static-1.2749",
  "trellis-theming": "/trellis-theming/static-1.1309",
  "ui-addon-teams": "/ui-addon-teams/static-1.21946",
  "quartz-auth": "/quartz-auth/static-1.1177",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9427",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5335",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9783",
  "ContentUtils": "/ContentUtils/static-1.69187",
  "customer-data-properties": "/customer-data-properties/static-1.52679",
  "forms-ai-lib": "/forms-ai-lib/static-1.4804",
  "forms-utils-lib": "/forms-utils-lib/static-1.13134",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6022",
  "react-dnd-compat": "/react-dnd-compat/static-1.4952",
  "react-tinymce": "/react-tinymce/static-1.56034",
  "tinymce-config": "/tinymce-config/static-2.55160",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10632",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3797",
  "HeadJS": "/HeadJS/static-2.803",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3480",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "hs-locale-management": "/hs-locale-management/static-1.318",
  "ui-fonts": "/ui-fonts/static-1.1089",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4648",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1167",
  "web-vitals": "/web-vitals/static-1.15",
  "batch-promise": "/batch-promise/static-1.1881",
  "external-options-client-types": "/external-options-client-types/static-1.4364",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7229",
  "quartz-i18n": "/quartz-i18n/static-1.1177",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8254",
  "graphql": "/graphql/static-1.89",
  "persist-promise": "/persist-promise/static-1.4038",
  "reporting-client-types": "/reporting-client-types/static-1.2714",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "growth-payments-core": "/growth-payments-core/static-1.26245",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5213",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1564",
  "quartz-routing": "/quartz-routing/static-1.932",
  "hs-story-utils": "/hs-story-utils/static-1.9761",
  "react-flip-move": "/react-flip-move/static-1.78",
  "nested-table": "/nested-table/static-1.571",
  "seat-types-lib": "/seat-types-lib/static-1.796",
  "timezone-utils": "/timezone-utils/static-2.5579",
  "react-create-root-preference": "/react-create-root-preference/static-1.78",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4808",
  "floating-ui": "/floating-ui/static-1.63",
  "react-aria": "/react-aria/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.112",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.583",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.487",
  "quartz-test": "/quartz-test/static-1.1177",
  "quartz-tracking": "/quartz-tracking/static-1.881",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.412",
  "chirp-fetch": "/chirp-fetch/static-1.2232",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "purchase-motions-components": "/purchase-motions-components/static-1.6408",
  "ts-schema": "/ts-schema/static-1.4317",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3295",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1735",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4993",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4040",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4371",
  "event-emitter": "/event-emitter/static-1.1291",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.348",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3931",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19304",
  "growth-data-modal": "/growth-data-modal/static-1.5936",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3401",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2746",
  "navigation-components": "/navigation-components/static-1.18893",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5388",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1240",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10605",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7986",
  "ui-universal-auth": "/ui-universal-auth/static-1.9459",
  "user-context": "/user-context/static-1.5457",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.468",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "stylex-utils": "/stylex-utils/static-1.147",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10669",
  "magpie-lib": "/magpie-lib/static-1.5782",
  "navigation-messaging": "/navigation-messaging/static-1.8220",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23183",
  "copilot-toolkit": "/copilot-toolkit/static-1.11899",
  "cms-field-types": "/cms-field-types/static-1.5148",
  "content-icons-ui": "/content-icons-ui/static-1.2399",
  "integrations-lib": "/integrations-lib/static-1.17119",
  "calling-global-api": "/calling-global-api/static-1.65717",
  "calling-internal-common": "/calling-internal-common/static-1.31658",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67099",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59393",
  "commerce-products-lib": "/commerce-products-lib/static-1.10604",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4583",
  "crm-links": "/crm-links/static-1.6658",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9998",
  "file-manager-components": "/file-manager-components/static-1.24574",
  "formula-editor": "/formula-editor/static-1.14813",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4452",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.971",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49751",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4206",
  "property-value-citations": "/property-value-citations/static-1.3293",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.192",
  "smart-property-lib": "/smart-property-lib/static-1.8361",
  "tiered-pricing": "/tiered-pricing/static-1.2007",
  "topics-actions-lib": "/topics-actions-lib/static-1.504",
  "trial-components-library": "/trial-components-library/static-1.14158",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9413",
  "zustand": "/zustand/static-1.85",
  "final-form": "/final-form/static-1.78",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "rich-text-lib": "/rich-text-lib/static-1.20349",
  "tinymce-themes": "/tinymce-themes/static-1.57130",
  "data-token-picker": "/data-token-picker/static-1.16929",
  "hub-http-contrib": "/hub-http-contrib/static-1.3376",
  "interframe": "/interframe/static-3.5091",
  "tinymce-data": "/tinymce-data/static-1.41245",
  "tinymce-plugins": "/tinymce-plugins/static-1.58274",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5550",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7134",
  "ui-addon-opt": "/ui-addon-opt/static-4.8702",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.672",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.484",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.40",
  "purchase-motions-api": "/purchase-motions-api/static-1.6411",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2559",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2774",
  "user-context-client": "/user-context-client/static-1.4844",
  "idb-keyval": "/idb-keyval/static-1.51",
  "magpie-types": "/magpie-types/static-1.5242",
  "nest": "/nest/static-1.573",
  "reactive-lib": "/reactive-lib/static-1.1055",
  "simple-logging-lib": "/simple-logging-lib/static-1.3387",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1255",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18422",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1821",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14534",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5944",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8113",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10706",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.973",
  "calling-error-reporting": "/calling-error-reporting/static-1.31665",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11377",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6872",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2125",
  "customer-data-tracking": "/customer-data-tracking/static-1.7218",
  "commerce-permissions": "/commerce-permissions/static-1.1113",
  "products-iframe-lib": "/products-iframe-lib/static-1.8641",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11053",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6780",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10754",
  "sales-views-client-types": "/sales-views-client-types/static-1.4592",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10159",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4482",
  "video-components-external": "/video-components-external/static-1.12201",
  "video-data-lib": "/video-data-lib/static-1.35859",
  "bark-lib": "/bark-lib/static-1.16850",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6226",
  "react-codemirror": "/react-codemirror/static-1.10979",
  "data-agent-kit": "/data-agent-kit/static-1.694",
  "feedback-loader": "/feedback-loader/static-1.29853",
  "fsm": "/fsm/static-1.4088",
  "policy-lib": "/policy-lib/static-1.7140",
  "react-colorpicker": "/react-colorpicker/static-2.10549",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10817",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15609",
  "hubs-service-types": "/hubs-service-types/static-1.1596",
  "salesImages": "/salesImages/static-1.596",
  "FileManagerLib": "/FileManagerLib/static-1.40214",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9289",
  "FileManagerCore": "/FileManagerCore/static-1.40073",
  "content-assistance-lib": "/content-assistance-lib/static-1.8241",
  "layout-dnd-components": "/layout-dnd-components/static-1.13015",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11990",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10220",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16604",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15612",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7947",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.799",
  "breeze-engine-core": "/breeze-engine-core/static-1.1099",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3344",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.522",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1496",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.23",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1087",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.203",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.542",
  "slack-ui-library": "/slack-ui-library/static-1.10735",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36902",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13310",
  "content-media-compositions": "/content-media-compositions/static-2.17317",
  "media-bridge-lib": "/media-bridge-lib/static-1.19447",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16420",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4843",
  "storybook-react": "/storybook-react/static-1.40",
  "academy-common-lib": "/academy-common-lib/static-1.15069",
  "audio-components": "/audio-components/static-1.6388",
  "FileManagerImages": "/FileManagerImages/static-1.37725",
  "video-components": "/video-components/static-1.14203",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.445",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4866",
  "video-embed": "/video-embed/static-1.36693",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9038",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29365",
  "ContentData": "/ContentData/static-1.69262",
  "layout-data-lib": "/layout-data-lib/static-1.10315",
  "academy-service-client": "/academy-service-client/static-1.4028",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4742",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7669",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9868",
  "wootric-nps": "/wootric-nps/static-1.7224",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "outpost": "/outpost/static-1.4489",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6921",
  "advanced-menus-core": "/advanced-menus-core/static-1.15620",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12492",
  "ExportDialog": "/ExportDialog/static-6.10714",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34899",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19325",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20793",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15619",
  "simple-menus-lib": "/simple-menus-lib/static-1.17136",
  "settings-ui-lib": "/settings-ui-lib/static-1.12860",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10874",
  "immutable-less": "/immutable-less/static-1.4987",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18200",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8363",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4253",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8386",
  "nav-meta": "/nav-meta/static-1.30530",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1152",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4569",
  "simple-data-table": "/simple-data-table/static-1.3571"
}
};
